import * as mutationsType from './mutationsType'

export default {
  //保存后台用户信息
  [mutationsType.RECEIVE_ADMIN_USER_INFO] (state, { adminUserInfo }) {
    state.adminUserInfo = adminUserInfo
  },
  //清除后台用户信息
  [mutationsType.CLEAR_ADMIN_USER_INFO] (state) {
    state.adminUserInfo = {}
  },
  // 更新后台token
  [mutationsType.UPDATE_ADMIN_TOKEN] (state,{token}) {
    state.adminUserInfo.token = token
  },
}
